<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <div class="row">
              <div class="col-4">نام کاربری:</div>
              <div class="col-8">{{ user.username }}</div>
            </div>

            <div class="row">
              <div class="col-4">شماره تماس:</div>
              <div class="col-8">{{ user.phone }}</div>
            </div>

            <div class="row">
              <div class="col-4">ایمیل:</div>
              <div class="col-8">{{ user.email }}</div>
            </div>

            <div class="row">
              <div class="col-8">تایید شماره:</div>
              <div class="col-4">{{ user.phoneVerified ? '✅' : '❌' }}</div>
            </div>

            <div class="row">
              <div class="col-8">تایید ایمیل:</div>
              <div class="col-4">{{ user.emailVerified ? '✅' : '❌' }}</div>
            </div>

            <div class="row">
              <div class="col-8">ورود با گوگل:</div>
              <div class="col-4">{{ user.googleVerified ? '✅' : '❌' }}</div>
            </div>

            <div class="row">
              <div class="col-8">ورود با اپل:</div>
              <div class="col-4">{{ user.appleVerified ? '✅' : '❌' }}</div>
            </div>

            <div class="row">
              <div class="col-4">کشور:</div>
              <div class="col-8">{{ user.country }}</div>
            </div>

            <div class="row">
              <div class="col-4">وضعیت:</div>
              <div class="col-8">{{ user.isActive ? 'فعال ✅' : 'غیر فعال ❌' }}</div>
            </div>

            <div class="row">
              <div class="col-4">حساب:</div>
              <div class="col-8">{{ user.isVerified ? 'تایید شده ✅' : 'تایید نشده ❌' }}</div>
            </div>

            <div class="row">
              <div class="col-4">platform:</div>
              <div class="col-8">{{ user.deviceInfo.platform }}</div>
            </div>

            <div class="row">
              <div class="col-4">Model:</div>
              <div class="col-8">{{ user.deviceInfo.deviceModel }}</div>
            </div>

            <div class="row">
              <div class="col-4">Version:</div>
              <div class="col-8">{{ user.deviceInfo.osVersion }}</div>
            </div>

            <div class="row">
              <div class="col-4">Version:</div>
              <div class="col-8">{{ user.deviceInfo.appVersion }}</div>
            </div>

            <div class="row">
              <div class="col-4">Build:</div>
              <div class="col-8">{{ user.deviceInfo.appBuildVersion }}</div>
            </div>

            <div class="em-separator separator-dashed"></div>
            <ul class="nav flex-column">
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0)" @click="sendNotif"
                  ><i class="la la-bell la-2x align-middle pr-2"></i>ارسال اعلان</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0)" @click="sendMessage"
                  ><i class="la la-bell la-2x align-middle pr-2"></i>ارسال پیام</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0)" @click="changePass"
                  ><i class="la la-bell la-2x align-middle pr-2"></i>عوض کردن رمز عبور</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0)" @click="changeActive"
                  ><i class="la la-bell la-2x align-middle pr-2"></i
                  >{{ user.isActive ? 'غیر فعال کردن' : 'فعال کردن' }} حساب کاربری</a
                >
              </li>
            </ul>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات کاربر</h4>
          </div>
          <div class="widget-body">
            <div class="col-10 ml-auto">
              <div class="section-title mt-3 mb-3"></div>
            </div>
            <form class="form-horizontal">
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">سکه</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" v-model="user.coin" />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد تیکت</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" v-model="user.ticket" />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">زمان پایان اشتراک</label>
                <div class="col-lg-6">
                  <date-picker
                    name="expireDate"
                    type="datetime"
                    inputFormat="YYYY-MM-DD HH:mm"
                    display-format="jYYYY-jMM-jDD HH:mm"
                    format="YYYY-MM-DD HH:mm"
                    locale="fa,en"
                    altFormat="MM-DD-YYYY HH:mm"
                    v-model="expireDate"
                  ></date-picker>
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">سطح</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" :value="user.level" disabled />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">xp</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" :value="user.xp" disabled />
                </div>
              </div>
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد بازی ها</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" :value="user.totalGames" disabled />
                </div>
              </div>
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد برد ها</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" :value="user.totalWins" disabled />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد باخت</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" :value="user.looses" disabled />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد بازی ها لیگ</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" :value="user.totalLeagueGames" disabled />
                </div>
              </div>
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد برد ها لیگ</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" :value="user.totalLeagueWins" disabled />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد بازی های مستر لیگ</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" :value="user.totalMasterGames" disabled />
                </div>
              </div>
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد برد های مستر لیگ</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" :value="user.totalMasterWins" disabled />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">پیام خوانده نشده</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" :value="user.messageBadge" disabled />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد spinner</label>
                <div class="col-lg-6">
                  <input type="number" class="form-control" v-model="user.spinCount" />
                </div>
              </div>

              <div v-if="user.lastLicense" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >اخرین اشتراک خریداری شده</label
                >
                <div class="col-lg-6">
                  <input
                    type="text"
                    class="form-control"
                    :value="user.lastLicense.title + ' - ' + user.lastLicense.price + ' تومان'"
                    disabled
                  />
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div>
              <h3>پیام های ارسال شده</h3>
              <div>
                <div class="border p-3 my-2" v-for="(message, index) in messages" :key="index">
                  <p>
                    <b> {{ new Date(message.createdAt).toLocaleString('fa-IR') }}</b>
                  </p>
                  <h4>{{ message.title }}</h4>
                  <p>{{ message.text }}</p>
                  <h4>{{ message.titleEn }}</h4>
                  <p>{{ message.textEn }}</p>
                  <p>{{ message.didUserSaw ? 'دیده شده' : 'دیده نشده' }}</p>
                  <button @click.prevent="editMessage(message)" class="btn btn-gradient-03">ویرایش پیام</button>
                  <button @click.prevent="deleteTheMessage(message)" class="btn btn-gradient-01 mx-4">حذف پیام</button>
                </div>
              </div>
            </div>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/users">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <message :modal="modalData" @clicked="sendMessageToUser" @edit="saveEditedMessage"></message>
    <changePassword :modal="passModal" @clicked="changeUserPassword"></changePassword>
    <!-- End Row -->
  </div>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import userService from '../../../services/userService';
export default {
  name: 'detail',
  components: {
    datePicker: VuePersianDatetimePicker,
    message: () => import('./messageModal'),
    changePassword: () => import('./ChangePass'),
  },
  props: ['userId'],
  data() {
    return {
      user: {},
      modalData: {
        saveToMessages: true,
        sendNotif: false,
      },
      expireDate: '',
      passModal: {},
      messages: [],
    };
  },
  created() {
    this.getUserData();
  },
  methods: {
    async getUserData() {
      const user = await userService.getUser(this.$route.query.id);
      this.user = user.user;
      this.messages = user.messages;
      const expire = new Date(this.user.licenseExpireDate);
      this.expireDate = format(expire);
      function format(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        var hh = date.getHours();
        var min = date.getMinutes();
        return [
          date.getFullYear(),
          '-',
          (mm > 9 ? '' : '0') + mm,
          '-',
          (dd > 9 ? '' : '0') + dd,
          ' ',
          (hh > 9 ? '' : '0') + hh,
          ':',
          (min > 9 ? '' : '0') + min,
        ].join('');
      }
    },

    async save() {
      const body = {
        licenseExpireDate: new Date(this.expireDate).toISOString(),
        coin: this.user.coin,
        ticket: this.user.ticket,
        spinCount: this.user.spinCount,
        _id: this.user._id,
      };
      try {
        await userService.updateUser(body);
        window.notif({ isError: false, mssg: 'اپدیت شد' });
        this.getUserData();
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });
      }
    },
    sendMessage() {
      this.modalData = {
        saveToMessages: true,
        sendNotif: false,
        title: '',
        titleEn: '',
        text: '',
        textEn: '',
      };
      window.$('#message').modal('show');
    },
    editMessage(message) {
      this.modalData = { ...message };
      window.$('#message').modal('show');
    },

    async saveEditedMessage(message) {
      try {
        await userService.editMessage(message);
        window.$('#message').modal('hide');
        window.notif({ isError: false, mssg: 'پیام ارسال شد' });
        await this.getUserData();
      } catch (err) {
        console.log(err);
      }
    },

    async deleteTheMessage(message) {
      try {
        await userService.deleteMessage(message._id);
        window.$('#message').modal('hide');
        window.notif({ isError: false, mssg: 'پیام حذف شد' });
        await this.getUserData();
      } catch (err) {
        console.log(err);
      }
    },

    sendNotif() {
      window.$('#notif').modal('show');
    },
    async changeActive() {
      try {
        await userService.changeStatus(this.$route.query.id);
        window.notif({ isError: false, mssg: 'وضعیت تغییر پیدا کرد' });
        this.getUserData();
      } catch (err) {
        console.log(err);
      }
    },
    changePass() {
      window.$('#password').modal('show');
    },
    async sendMessageToUser(params) {
      try {
        await userService.sendMessage({
          userId: this.$route.query.id,
          mssg: params,
          sendNotif: params.sendNotif,
          saveToMessages: params.saveToMessages,
        });
        window.$('#message').modal('hide');
        window.notif({ isError: false, mssg: 'پیام ارسال شد' });
      } catch (err) {
        console.log(err);
      }
    },

    async changeUserPassword(params) {
      try {
        await userService.changePass({
          userId: this.$route.query.id,
          password: params.password,
          notify: params.notify,
        });
        window.$('#password').modal('hide');
        window.notif({ isError: false, mssg: 'کلمه عبور عوض شد' });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
